import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMsal } from '@azure/msal-react'
import { InteractionStatus } from '@azure/msal-browser'
import { useAuth } from '../auth/AuthContext'
import Spinner from '../components/Spinner'

/**
 * AuthCallback — landing page for the MSAL redirect URI.
 *
 * MSAL processes the Azure AD authorization code here (via MsalProvider's
 * handleRedirectPromise). Once interaction is complete, AuthContext acquires
 * a token silently and calls the backend /auth/callback endpoint. This
 * component waits for that to finish, then navigates to the app.
 */
export default function AuthCallback() {
  const { user, authError } = useAuth()
  const { inProgress } = useMsal()
  const navigate = useNavigate()

  useEffect(() => {
    if (inProgress !== InteractionStatus.None) return
    if (user) {
      navigate('/experiments', { replace: true })
    } else if (authError) {
      navigate('/login', { replace: true, state: { authError: true } })
    }
  }, [user, authError, inProgress, navigate])

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Spinner size="lg" label="Signing in…" />
    </div>
  )
}
